<template>

</template>

<script>
	export default {
		created() {
			this.$store.dispatch('destroyToken')
			.then(response => {
				this.$router.push({ name: 'login' })
				iziToast.show({
					color: 'dark',
					icon: 'fa fa-envelope-open-o',
					title: 'System',
					message: 'Well done! Have a nice work!',
					position: 'topRight', 
					progressBarColor: '#777',

				});
			})
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/pages/auth/logout.vue